import React, { Component } from 'react'
import Partnerships from './partnerships'
import CommunityEfforts from './community-efforts'

class OurPartnershipsBlock extends Component {

  state = {
    items: [true]
  }

  componentDidMount() {
   if ( this.props.partnerships?.length > 0 ) {
    this._showComponent(0)
   } else {
    this._showComponent(1)
   }
  }

  _showComponent = (key) => {
    let items = [];
    items[key] = true
    this.setState({ items })
  }

  render() {

    let { items } = this.state

    let { partnershipsTitle, partnerships, communityEffortsTitle, communityEfforts } = this.props

    return (
      <section className='our-partnerships-block'>
        <div className='our-partnerships-block__inner'>

        <div className='our-partnerships-block__content'>

          <div className='our-partnerships-block__menu'>

            <ul>
              { partnerships?.length > 0 && <li className={items[0] ? `active` : ''} onClick={() => this._showComponent(0)} >{partnershipsTitle}</li> }
              { communityEfforts?.length > 0 && <li className={items[1] ? `active` : ''} onClick={() => this._showComponent(1)} >{communityEffortsTitle}</li> }
            </ul>

          </div>

          <div className='our-partnerships-block__components'>

            { partnerships?.length > 0 && 
              <div className={`our-partnerships-block__partnerships ${items[0] ? 'active' : ''}`}>
                <Partnerships {...this.props} />
              </div>
            }
            { communityEfforts?.length > 0 && 
              <div className={`our-partnerships-block__community-efforts ${items[1] ? 'active' : ''}`}>
                <CommunityEfforts {...this.props} />
              </div>
            }

          </div>

        </div>
            
        </div>
      </section>
    )
  }
}

export default OurPartnershipsBlock
